import { render, staticRenderFns } from "./ParserCode.vue?vue&type=template&id=271daada&scoped=true&"
import script from "./ParserCode.vue?vue&type=script&lang=js&"
export * from "./ParserCode.vue?vue&type=script&lang=js&"
import style0 from "./ParserCode.vue?vue&type=style&index=0&id=271daada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271daada",
  null
  
)

export default component.exports